import React from "react"
import './style.css';
import Die from "./components/Die"
import { nanoid } from "nanoid"
import Confetti from "react-confetti"
import useInterval from 'react-useinterval';


export default function App() {
      const [dice, setDice] = React.useState(getRandomNum())
      const [tenzies, setTenzies] = React.useState(false) // state whether user win the game
      const [counter, setCounter] = React.useState(0)

      // time counter
      const [time, setTime] = React.useState(0)
      const [isRunning, setIsRunning] = React.useState(false)
      const [bestTime, setBestTime] = React.useState(() => localStorage.getItem("bestTime") || "")



      React.useEffect(() => {
            localStorage.setItem("bestTime", bestTime)
      }, [bestTime])




      React.useEffect(() => {
            const isAllHeld = dice.every(die => die.isHeld)
            const oneValue = dice[0].value
            const isallSameValue = dice.every(die => die.value === oneValue)
            if (isAllHeld && isallSameValue) {
                  setTenzies(true)
                  setIsRunning(false)
            }
      }, [dice])



      // get random number from 1 - 6
      function getRandomNum() {
            const newArray = []
            for (let i = 0; i < 10; i++) {
                  newArray.push({
                        value: Math.ceil(Math.random() * 6),
                        isHeld: false,
                        id: nanoid()
                  })
            }
            return newArray
      }


      function getNewDice() {
            if (tenzies) {
                  // if won the game -> reset the game
                  // here are 4 states -> do not forget the tenzies to default false
                  // and 1 for track best time
                  setDice(getRandomNum())
                  setTenzies(false)
                  setCounter(0)
                  setTime(0)
                  setBestTime(min)
            } else {
                  setDice(oldDice => oldDice.map(die => {
                        return die.isHeld
                              ? die
                              : {
                                    value: Math.ceil(Math.random() * 6),
                                    isHeld: false,
                                    id: nanoid()
                              }
                  }))
                  setCounter(prevCounter => prevCounter + 1)
            }

      }


      function heldDice(id) {
            setDice(oldDice => oldDice.map(die => {
                  return die.id === id
                        ? { ...die, isHeld: !die.isHeld }
                        : die
            }))
            setIsRunning(true)
      }


      //useInterval(callback, delay?: number)
      function GetTime() {
            useInterval(() => {
                  setTime(time + 1)
            }, isRunning ? 1000 : null)
            return time
      }

      // calculate each round time
      function IncludeTime() {
            if (tenzies) {
                  const thisRoundTime = String(time)
                  return thisRoundTime
            }
      }

      const arr = []
      arr.push(IncludeTime())
      const min = Math.min(...arr)



      const diceElements = dice.map(die =>
            <Die key={die.id}
                  value={die.value}
                  isHeld={die.isHeld}
                  heldDice={() => heldDice(die.id)}
            />)



      return (
            <main>
                  {tenzies && <Confetti />}
                  <h1 className="title">Tenzies</h1>
                  <p className="instructions">Roll until all dice are the same.
                        Click each die to freeze it at its current value between rolls.</p>
                  <h3 className="counter">Rolls: {counter}</h3>

                  <h4>Time: {<GetTime />}s</h4>

                  <div className="container">
                        {diceElements}
                  </div>
                  <button onClick={getNewDice}>{tenzies ? "New Game" : "Roll"}</button>
                  <p className="time-records">🎉 Your Best Time 🎉: {bestTime}s</p>

            </main>
      )
}